import { MLOPS_REFERENCE_ENG_URL } from '@/constant/app'

export enum CourseEnum {
  MLOps = 'MLOps',
  RECOMMENDER_SYSTEM = 'Recommender System',
  SPEECH = 'Speech',
  COMPUTER_VISION = 'Computer Vision',
  NATURAL_LANGUAGE_PROCESSING = 'Natural Language Processing',
  DATA_ENGINEERING = 'Data Engineering',
  MACHINE_LEARNING = 'Machine Learning',
  MACHINE_LEARNING_ENGINEERING = 'Machine Learning Engineering',
  DATA_ANALYTICS = 'Data Analytics',
  BUSINESS_INTELLIGENCE = 'Business Intelligence',
  LLM = 'LLM',
  DEEP_LEARNING = 'Deep Learning',
  FUNDAMENTALS_OF_SOFTWARE_ENGINEERING = 'Fundamentals of Software Engineering',
  MLOPS_DATAOPS = 'MLOps & DataOps',
  SOFTWARE_ENGINEERING = 'Software Engineering',
}

export enum ModuleCourse {
  AIDE = 'AIDE',
  DSAA = 'DSAA',
  FSWE = 'FSWE',
  BAIW = 'BAIW',
}

export enum DiscountEnum {
  mlops = 'mlops',
  igds = 'igds',
  cda = 'cda',
  aide = 'aide',
  dsaa = 'dsaa',
}

export type CourseType = 'recording' | 'live'

export const courseGenerals = [
  {
    id: 'mlops-1',
    roadMapImage: '/images/modules/mlops-1.jpg',
    roadmapHeading: (
      <p>
        MLOps 1 Roadmap bởi <span className="text-primary">FSDS</span>
      </p>
    ),
    roadmapHeadingEng: (
      <p>
        MLOps 1 Roadmap by <span className="text-primary">FSDS</span>
      </p>
    ),
    title: 'MLOps 1',
    finalProject: 1,
    duration: 2, // month
    durationMakeProject: 1, // month
    accessDuration: 12, // month
    calendar: '2, 4, 6 (8.00 pm - 10.00 pm)',
    courseName: CourseEnum.MLOps,
    instructors: [1, 9],
    discounts: [],
    urlCurriculum: {
      mlops:
        'https://docs.google.com/spreadsheets/d/16dQjvlGLSAfl9aoGheGGqDNZuktLPJ4q/edit?gid=908181129#gid=908181129',
      igds: '',
      cda: '',
    },
    detailCourseEngUrl: MLOPS_REFERENCE_ENG_URL,
    course: DiscountEnum.mlops,
    type: 'live',
    labNumber: 15,
    description:
      'Khóa học xây dựng nền tảng MLOps vững chắc, từ Linux và Bash đến FastAPI, Docker, Kubernetes và quy trình CI/CD trên đám mây GCP. Học viên rèn luyện triển khai, giám sát và tối ưu một hệ thống OCR hoàn chỉnh, nắm trọn chu trình phát triển – vận hành mô hình.',
    descriptionEng:
      'This module lays a solid MLOps foundation, covering Linux, Bash, FastAPI, Docker, Kubernetes, and cloud‑based CI/CD on GCP. Learners deploy, monitor, and refine a full OCR pipeline, mastering the end‑to‑end ML lifecycle.',
  },
  {
    id: 'mlops-2',
    roadMapImage: '/images/modules/mlops-2.jpg',
    roadmapHeading: (
      <p>
        MLOps 2 Roadmap bởi <span className="text-primary">FSDS</span>
      </p>
    ),
    roadmapHeadingEng: (
      <p>
        MLOps 2 Roadmap by <span className="text-primary">FSDS</span>
      </p>
    ),
    title: 'MLOps 2',
    finalProject: 1,
    duration: 2, // month
    durationMakeProject: 1, // month
    accessDuration: 12, // month
    calendar: '2, 4, 6 (8.00 pm - 10.00 pm)',
    courseName: CourseEnum.MLOps,
    instructors: [1, 9],
    discounts: [],
    urlCurriculum: {
      mlops:
        'https://docs.google.com/spreadsheets/d/16dQjvlGLSAfl9aoGheGGqDNZuktLPJ4q/edit?gid=221663282#gid=221663282',
      igds: '',
      cda: '',
    },
    detailCourseEngUrl: MLOPS_REFERENCE_ENG_URL,
    course: DiscountEnum.mlops,
    type: 'live',
    labNumber: 10,
    description:
      'Khóa học tập trung thiết kế hạ tầng dữ liệu cho Machine Learning với Data Lake‑house, Mesh và Fabric. Học viên xây dựng pipeline batch và stream bằng Spark, Flink, Kafka, quản lý Feature Store bằng Feast và vận hành Lakehouse qua Delta Lake, Trino, Hive.',
    descriptionEng:
      'The course explores modern ML data architecture, including Lake‑house, Mesh, and Fabric paradigms. Participants create batch and streaming pipelines with Spark, Flink, Kafka, manage a Feast feature store, and operate a Lakehouse using Delta Lake, Trino, and Hive.',
  },
  {
    id: 'mlops-3',
    roadMapImage: '/images/modules/mlops-3.jpg',
    roadmapHeading: (
      <p>
        MLOps 3 Roadmap bởi <span className="text-primary">FSDS</span>
      </p>
    ),
    roadmapHeadingEng: (
      <p>
        MLOps 3 Roadmap by <span className="text-primary">FSDS</span>
      </p>
    ),
    title: 'MLOps 3',
    finalProject: 1,
    duration: 2, // month
    durationMakeProject: 1, // month
    accessDuration: 12, // month
    calendar: '2, 4, 6 (8.00 pm - 10.00 pm)',
    courseName: CourseEnum.MLOps,
    instructors: [1, 9],
    discounts: [],
    urlCurriculum: {
      mlops:
        'https://docs.google.com/spreadsheets/d/16dQjvlGLSAfl9aoGheGGqDNZuktLPJ4q/edit?gid=2019808715#gid=2019808715',
      igds: '',
      cda: '',
    },
    detailCourseEngUrl: MLOPS_REFERENCE_ENG_URL,
    course: DiscountEnum.mlops,
    type: 'live',
    labNumber: 15,
    description:
      'Module chuyên sâu tối ưu hiệu năng và triển khai mô hình ở quy mô lớn. Nội dung gồm thiết kế pipeline huấn luyện, phục vụ mô hình với Ray Serve, Triton, KServe và quản trị toàn bộ chu trình trên Kubeflow kèm giám sát thời gian thực.',
    descriptionEng:
      'This advanced module focuses on performance and scalable deployment. It covers high‑performance Python, training pipeline design, serving with Ray Serve, Triton, and KServe, and end‑to‑end lifecycle governance in Kubeflow with real‑time monitoring.',
  },
  {
    id: 'mlops-4',
    roadMapImage: '/images/modules/mlops-4.jpg',
    roadmapHeading: (
      <p>
        MLOps 4 Roadmap bởi <span className="text-primary">FSDS</span>
      </p>
    ),
    roadmapHeadingEng: (
      <p>
        MLOps 4 Roadmap by <span className="text-primary">FSDS</span>
      </p>
    ),
    title: 'MLOps 4',
    finalProject: 1,
    duration: 2, // month
    durationMakeProject: 1, // month
    accessDuration: 12, // month
    calendar: '2, 4, 6 (8.00 pm - 10.00 pm)',
    courseName: CourseEnum.MLOps,
    instructors: [1, 9],
    discounts: [],
    urlCurriculum: {
      mlops:
        'https://docs.google.com/spreadsheets/d/16dQjvlGLSAfl9aoGheGGqDNZuktLPJ4q/edit?gid=1690487574#gid=1690487574',
      igds: '',
      cda: '',
    },
    detailCourseEngUrl: MLOPS_REFERENCE_ENG_URL,
    course: DiscountEnum.mlops,
    type: 'recording',
    labNumber: 10,
    description:
      'Khóa học hoàn thiện kiến trúc MLOps doanh nghiệp: dbt, kiểm thử dữ liệu, DataHub, API Gateway, đào tạo phân tán và gRPC. Học viên còn tiếp cận LLMOps với vLLM, LangChain, Milvus để triển khai các ứng dụng ngôn ngữ lớn.',
    descriptionEng:
      'The final module consolidates enterprise‑grade MLOps: dbt transformations, data validation, DataHub metadata, API gateways, distributed training, and gRPC optimization. Learners also dive into LLMOps using vLLM, LangChain, and Milvus for large‑language‑model applications.',
  },
  {
    id: 'machine-learning',
    roadMapImage: '/images/modules/ml.jpg',
    roadmapHeading: (
      <p>
        Machine Learning Roadmap bởi <span className="text-primary">FSDS</span>
      </p>
    ),
    title: 'Machine Learning',
    finalProject: 1,
    duration: 2, // month
    durationMakeProject: 1, // month
    accessDuration: 12, // month
    calendar: '3, 5, 7 (8.00 pm - 10.00 pm)',
    courseName: CourseEnum.MACHINE_LEARNING,
    instructors: [7],
    discounts: [],
    urlCurriculum: {
      mlops: '',
      igds: '',
      cda: '',
      aide: 'https://docs.google.com/spreadsheets/d/1cNkOrf0_QpzMw76iTPAaq3ShFgLW6d3y/edit?gid=2019808715#gid=2019808715',
      dsaa: 'https://docs.google.com/spreadsheets/d/1uzmtiHSaCKV1gJ2yKUyfu1lUJo3HKnNJxv4GAUp3r0U/edit?gid=1624458990#gid=1624458990',
    },
    type: 'live',
    labNumber: 14,
    description:
      'Khóa học đi sâu vào thuật toán truyền thống và ensemble, ứng dụng vào phân tích tín dụng và phân khúc khách hàng với giải thích mô hình minh bạch.',
    descriptionEng:
      'This module delves into traditional algorithms and ensembles, applying them to credit analysis and customer segmentation with transparent model explanations.',
  },
  {
    id: 'business-intelligence',
    roadMapImage: '/images/modules/bi.jpg',
    roadmapHeading: (
      <p>
        Business Intelligence Roadmap bởi <span className="text-primary">FSDS</span>
      </p>
    ),
    title: 'Business Intelligence',
    finalProject: 1,
    duration: 2, // month
    durationMakeProject: 1, // month
    accessDuration: 12,
    calendar: '2, 4, 6 (8.00 pm - 10.00 pm)',
    courseName: CourseEnum.BUSINESS_INTELLIGENCE,
    instructors: [8],
    discounts: [],
    urlCurriculum: {
      mlops: '',
      igds: '',
      cda: '',
      dsaa: 'https://docs.google.com/spreadsheets/d/1uzmtiHSaCKV1gJ2yKUyfu1lUJo3HKnNJxv4GAUp3r0U/edit?gid=1271883065#gid=1271883065',
    },
    type: 'recording',
    labNumber: 20,
    description:
      'Trang bị kiến thức BI cốt lõi: mô hình dữ liệu, ETL / ELT, trực quan hóa và kể chuyện bằng dữ liệu. Học viên thực hành truy vấn BigQuery, xây dựng báo cáo Power BI và tối ưu mô hình dữ liệu.',
    descriptionEng:
      'Covers BI fundamentals—data modeling, ETL/ELT, advanced visualization, and data storytelling. Participants query BigQuery, craft Power BI reports, and optimize data models.',
  },
  {
    id: 'deep-learning',
    roadMapImage: '/images/modules/dl.jpg',
    roadmapHeading: (
      <p>
        Deep Learning Roadmap bởi <span className="text-primary">FSDS</span>
      </p>
    ),
    title: 'Deep Learning',
    finalProject: 1,
    duration: 2, // month
    durationMakeProject: 1, // month
    accessDuration: 12, // month
    calendar: '3, 5, 7 - (8.00 pm - 10.00 pm)',
    courseName: CourseEnum.DEEP_LEARNING,
    instructors: [7],
    discounts: [],
    urlCurriculum: {
      mlops: '',
      igds: 'https://docs.google.com/spreadsheets/d/14c7ER4ruuf0YjtLX2V7sBcLpMhWvY2J2u3DBWkOV5LM/edit?gid=180871786#gid=180871786',
      cda: '',
      dsaa: 'https://docs.google.com/spreadsheets/d/1uzmtiHSaCKV1gJ2yKUyfu1lUJo3HKnNJxv4GAUp3r0U/edit?gid=180871786#gid=180871786',
    },
    course: DiscountEnum.igds,
    type: 'live',
    labNumber: 12,
    description:
      'Toàn diện về CNN, RNN và Transformer, bao gồm nén mô hình và NLP. Dự án thực tế như eKYC, phân tích cảm xúc và tóm tắt báo cáo tài chính.',
    descriptionEng:
      'Comprehensive coverage of CNNs, RNNs, and Transformers, including model compression and NLP. Real projects span eKYC, sentiment analysis, and financial report summarization.',
  },
  {
    id: 'computer-vision',
    roadMapImage: '/images/modules/cv.jpg',
    roadmapHeading: (
      <p>
        Advanced Computer Vision Roadmap bởi <span className="text-primary">FSDS</span>
      </p>
    ),
    title: 'Advanced Computer Vision',
    finalProject: 1,
    duration: 2, // month
    durationMakeProject: 0, // month
    accessDuration: 12, // month
    calendar: '',
    courseName: CourseEnum.COMPUTER_VISION,
    instructors: [5],
    discounts: [],
    urlCurriculum: {
      mlops: '',
      igds: 'https://docs.google.com/spreadsheets/d/14c7ER4ruuf0YjtLX2V7sBcLpMhWvY2J2u3DBWkOV5LM/edit?gid=911739631#gid=911739631',
      cda: '',
      dsaa: 'https://docs.google.com/spreadsheets/d/14c7ER4ruuf0YjtLX2V7sBcLpMhWvY2J2u3DBWkOV5LM/edit?gid=911739631#gid=911739631',
    },
    course: DiscountEnum.igds,
    type: 'recording',
    labNumber: 22,
    description:
      'Từ xử lý ảnh cổ điển đến Vision Transformer và Stable Diffusion, áp dụng vào giám sát giao thông và nhận diện tài liệu.',
    descriptionEng:
      'Ranges from classic image processing to Vision Transformers and Stable Diffusion, applied to traffic monitoring and document recognition.',
  },
  {
    id: 'nlp',
    roadMapImage: '/images/modules/nlp.jpg',
    roadmapHeading: (
      <p>
        Advanced Natural Language Processing Roadmap bởi <span className="text-primary">FSDS</span>
      </p>
    ),
    title: 'Advanced Natural Language Processing',
    finalProject: 1,
    duration: 2, // month
    durationMakeProject: 0, // month
    accessDuration: 12, // month
    calendar: '',
    courseName: CourseEnum.NATURAL_LANGUAGE_PROCESSING,
    instructors: [4],
    discounts: [],
    urlCurriculum: {
      mlops: '',
      igds: 'https://docs.google.com/spreadsheets/d/14c7ER4ruuf0YjtLX2V7sBcLpMhWvY2J2u3DBWkOV5LM/edit?gid=911739631#gid=911739631',
      cda: '',
      dsaa: 'https://docs.google.com/spreadsheets/d/14c7ER4ruuf0YjtLX2V7sBcLpMhWvY2J2u3DBWkOV5LM/edit?gid=911739631#gid=911739631',
    },
    type: 'recording',
    labNumber: 19,
    description:
      'Chuyên sâu Transformer, fine‑tuning, RAG và tác tử ngôn ngữ, phát triển chatbot, trích xuất thông tin và hệ tri thức.',
    descriptionEng:
      'Focuses on Transformers, fine‑tuning, RAG, and language agents to build chatbots, information extraction, and knowledge graphs.',
  },
  {
    id: 'speech',
    roadMapImage: '/images/modules/speech.jpg',
    roadmapHeading: (
      <p>
        Speech Roadmap bởi <span className="text-primary">FSDS</span>
      </p>
    ),
    title: 'Speech',
    finalProject: 1,
    duration: 2, // month
    durationMakeProject: 0, // month
    accessDuration: 12, // month
    calendar: '',
    courseName: CourseEnum.SPEECH,
    instructors: [10],
    discounts: [],
    urlCurriculum: {
      mlops: '',
      igds: 'https://docs.google.com/spreadsheets/d/14c7ER4ruuf0YjtLX2V7sBcLpMhWvY2J2u3DBWkOV5LM/edit?gid=1912914358#gid=1912914358',
      cda: '',
      dsaa: 'https://docs.google.com/spreadsheets/d/14c7ER4ruuf0YjtLX2V7sBcLpMhWvY2J2u3DBWkOV5LM/edit?gid=1912914358#gid=1912914358',
    },
    type: 'recording',
    labNumber: 17,
    description:
      'Bao quát chuỗi xử lý giọng nói từ MFCC đến Whisper, Tacotron2 và SpeechT5, thực hành ASR và TTS trên bộ dữ liệu chuẩn.',
    descriptionEng:
      'Spans the speech pipeline from MFCCs to Whisper, Tacotron2, and SpeechT5, with hands‑on ASR and TTS using standard datasets.',
  },
  {
    id: 'llm',
    roadMapImage: '/images/modules/llm.jpg',
    roadmapHeading: (
      <p>
        LLM Roadmap bởi <span className="text-primary">FSDS</span>
      </p>
    ),
    title: 'Large Language Models',
    finalProject: 1,
    duration: 2, // month
    durationMakeProject: 0, // month
    accessDuration: 12, // month
    calendar: '',
    courseName: CourseEnum.LLM,
    instructors: [6],
    discounts: [],
    urlCurriculum: {
      mlops: '',
      igds: 'https://docs.google.com/spreadsheets/d/14c7ER4ruuf0YjtLX2V7sBcLpMhWvY2J2u3DBWkOV5LM/edit?gid=2124735739#gid=2124735739',
      cda: '',
      dsaa: 'https://docs.google.com/spreadsheets/d/14c7ER4ruuf0YjtLX2V7sBcLpMhWvY2J2u3DBWkOV5LM/edit?gid=2124735739#gid=2124735739',
    },
    type: 'recording',
    labNumber: 17,
    description:
      'Giới thiệu toàn bộ vòng đời LLM: Prompt Engineering, Fine‑tuning, RAG và tối ưu suy luận với QLoRA, vLLM.',
    descriptionEng:
      'Covers the complete LLM lifecycle—prompting, fine‑tuning, RAG, and inference optimization with QLoRA and vLLM.',
  },
  {
    id: 'rec-sys',
    roadMapImage: '/images/modules/rec-sys.jpg',
    roadmapHeading: (
      <p>
        Recommendation Systems Roadmap bởi <span className="text-primary">FSDS</span>
      </p>
    ),
    title: 'Recommendation Systems',
    finalProject: 1,
    duration: 2, // month
    durationMakeProject: 0, // month
    accessDuration: 12, // month
    calendar: '',
    courseName: CourseEnum.RECOMMENDER_SYSTEM,
    instructors: [2],
    discounts: [],
    urlCurriculum: {
      mlops: '',
      igds: 'https://docs.google.com/spreadsheets/d/14c7ER4ruuf0YjtLX2V7sBcLpMhWvY2J2u3DBWkOV5LM/edit?gid=764090612#gid=764090612',
      cda: '',
      dsaa: 'https://docs.google.com/spreadsheets/d/14c7ER4ruuf0YjtLX2V7sBcLpMhWvY2J2u3DBWkOV5LM/edit?gid=764090612#gid=764090612',
    },
    type: 'recording',
    labNumber: 18,
    description:
      'Từ Collaborative Filtering đến mô hình Two‑Tower dùng LLM, bao gồm A/B testing, Bandit và giải thích kết quả.',
    descriptionEng:
      'Moves from collaborative filtering to LLM‑enhanced Two‑Tower models, incorporating A/B testing, bandits, and explainability.',
  },
  {
    id: 'llmops-agentops',
    roadMapImage: '/images/modules/llmops-agentops.jpg',
    roadmapHeading: (
      <p>
        LLMOps & AgentOps Roadmap bởi <span className="text-primary">FSDS</span>
      </p>
    ),
    title: 'LLMOps & AgentOps',
    finalProject: 1,
    duration: 2, // month
    durationMakeProject: 1, // month
    calendar: '3, 5 - (8.00 pm - 10.00 pm)',
    courseName: CourseEnum.MLOps,
    instructors: [9],
    discounts: [],
    urlCurriculum: {
      mlops:
        'https://docs.google.com/spreadsheets/d/16dQjvlGLSAfl9aoGheGGqDNZuktLPJ4q/edit?gid=114912761#gid=114912761',
      igds: '',
      cda: '',
    },
    course: DiscountEnum.mlops,
    type: 'live',
    labNumber: 12,
    description:
      'Module dành cho những ai đã có nền tảng về Transformer và MLOps, muốn đưa mô hình ngôn ngữ lớn (LLMs) và AI Agent vào sản phẩm thực tế.',
    descriptionEng:
      'Module for those who already have a foundation in Transformers and MLOps, looking to integrate large language models (LLMs) and AI agents into real products.',
  },
  {
    id: 'fundamentals-of-software-engineering',
    roadMapImage: '/images/modules/fundamentals-of-software-engineering.jpg',
    roadmapHeading: (
      <p>
        Fundamentals of Software Engineering Roadmap bởi <span className="text-primary">FSDS</span>
      </p>
    ),
    title: 'Fundamentals of Software Engineering for Data',
    finalProject: 1,
    duration: 2, // month
    durationMakeProject: 1, // month
    calendar: '3, 5 - (8.00 pm - 10.00 pm)',
    courseName: CourseEnum.FUNDAMENTALS_OF_SOFTWARE_ENGINEERING,
    instructors: [12],
    discounts: [],
    urlCurriculum: {
      mlops:
        'https://docs.google.com/spreadsheets/d/16dQjvlGLSAfl9aoGheGGqDNZuktLPJ4q/edit?gid=1946906387#gid=1946906387',
      igds: '',
      cda: '',
      aide: 'https://docs.google.com/spreadsheets/d/1cNkOrf0_QpzMw76iTPAaq3ShFgLW6d3y/edit?gid=1946906387#gid=1946906387',
      dsaa: 'https://docs.google.com/spreadsheets/d/1uzmtiHSaCKV1gJ2yKUyfu1lUJo3HKnNJxv4GAUp3r0U/edit?gid=735858660#gid=735858660',
    },
    type: 'live',
    labNumber: 11,
    description:
      'Module được thiết kế thân thiện với newbie hoàn toàn chưa có kiến thức về kỹ thuật phần mềm, giúp bạn từng bước xây dựng nền tảng vững chắc từ con số 0.',
    descriptionEng:
      'Module designed for absolute beginners with no prior knowledge of software engineering, helping you build a solid foundation step by step from zero.',
  },
  {
    id: 'mlops-dataops',
    roadMapImage: '/images/modules/aide/mlops-dataops.jpg',
    roadmapHeading: (
      <p>
        MLOps & DataOps Roadmap bởi <span className="text-primary">FSDS</span>
      </p>
    ),
    title: 'MLOps & DataOps',
    finalProject: 1,
    duration: 2, // month
    durationMakeProject: 1, // month
    calendar: '2, 4, 6 (8.00 pm - 10.00 pm)',
    courseName: CourseEnum.MLOPS_DATAOPS,
    instructors: [1, 9],
    discounts: [],
    urlCurriculum: {
      mlops: '',
      igds: '',
      cda: '',
      aide: 'https://docs.google.com/spreadsheets/d/1cNkOrf0_QpzMw76iTPAaq3ShFgLW6d3y/edit?gid=908181129#gid=908181129',
    },
    type: 'live',
    labNumber: 19,
    description:
      'Module được thiết kế thân thiện với newbie hoàn toàn chưa có kiến thức về kỹ thuật phần mềm, giúp bạn từng bước xây dựng nền tảng vững chắc từ con số 0.',
    descriptionEng:
      'Module designed for absolute beginners with no prior knowledge of software engineering, helping you build a solid foundation step by step from zero.',
  },
  {
    id: 'data-engineering',
    roadMapImage: '/images/modules/aide/data-engineering.jpg',
    roadmapHeading: (
      <p>
        Data Engineering Roadmap bởi <span className="text-primary">FSDS</span>
      </p>
    ),
    title: 'Data Engineering',
    finalProject: 1,
    duration: 2, // month
    durationMakeProject: 1, // month
    calendar: '2, 4, 6 (8.00 pm - 10.00 pm)',
    courseName: CourseEnum.DATA_ENGINEERING,
    instructors: [9],
    discounts: [],
    urlCurriculum: {
      mlops: '',
      igds: '',
      cda: '',
      aide: 'https://docs.google.com/spreadsheets/d/1cNkOrf0_QpzMw76iTPAaq3ShFgLW6d3y/edit?gid=221663282#gid=221663282',
    },
    type: 'live',
    labNumber: 19,
    description:
      'Module được thiết kế thân thiện với newbie hoàn toàn chưa có kiến thức về kỹ thuật phần mềm, giúp bạn từng bước xây dựng nền tảng vững chắc từ con số 0.',
    descriptionEng:
      'Module designed for absolute beginners with no prior knowledge of software engineering, helping you build a solid foundation step by step from zero.',
  },
  {
    id: 'machine-learning-engineering',
    roadMapImage: '/images/modules/ml-engineering.jpg',
    roadmapHeading: (
      <p>
        Machine Learning Engineering Roadmap bởi <span className="text-primary">FSDS</span>
      </p>
    ),
    title: 'Machine Learning Engineering',
    finalProject: 1,
    duration: 2, // month
    durationMakeProject: 1, // month
    accessDuration: 12, // month
    calendar: '2, 4, 6 (8.00 pm - 10.00 pm)',
    courseName: CourseEnum.MACHINE_LEARNING_ENGINEERING,
    instructors: [1, 9],
    discounts: [],
    urlCurriculum: {
      mlops: '',
      igds: '',
      cda: '',
      aide: 'https://docs.google.com/spreadsheets/d/1cNkOrf0_QpzMw76iTPAaq3ShFgLW6d3y/edit?gid=2019808715#gid=2019808715',
      dsaa: 'https://docs.google.com/spreadsheets/d/14c7ER4ruuf0YjtLX2V7sBcLpMhWvY2J2u3DBWkOV5LM/edit?gid=1624458990#gid=1624458990',
    },
    type: 'live',
    labNumber: 14,
    description:
      'Khóa học đi sâu vào thuật toán truyền thống và ensemble, ứng dụng vào phân tích tín dụng và phân khúc khách hàng với giải thích mô hình minh bạch.',
    descriptionEng:
      'This module delves into traditional algorithms and ensembles, applying them to credit analysis and customer segmentation with transparent model explanations.',
  },
]

export type CourseGeneral = (typeof courseGenerals)[number]
